/**
 * Calculates the real maximum value that can be reached by the stepper.
 * This is non-trivial because we have to account for `step` values that do not divide evenly into
 * the range of values between `min` and `max`.
 *
 * For example, if the developer sets the max to 29 and the step to 10, then the increment button
 * should be disabled when the value greater than 20.
 */
export const calculateRealMax = (min: number, max: number, step: number): number => {
  if (max === Infinity) return Infinity;

  const remainder = (max - min) % step;
  return max - remainder;
};
